import * as React from 'react';
import * as c from 'models/constants';
import * as moment from 'moment';
import { translate } from 'react-i18next';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { imgSrcAttributes, thumbUrl, truncateText } from 'helpers/common';
import { browserHistory } from 'react-router';

export interface IProps {
	sectionType?: string;
	sectionItem: IPortalPageSectionItem;
	isLastItemInRow?: boolean;
	isFirstItemInRow?: boolean;
	t?: (key: string) => string;
	isDragging?: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewSectionItemArticle extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	private onCardClick(e: any, url: string, isDragging: boolean) {
		if (!isDragging) {
			e.preventDefault();
			e.stopPropagation();
			browserHistory.push(url);
		}
	}

	private onAuthorClick(e: any, userCodeElement: ISectionTextElement, isDragging: boolean) {
		if (!isDragging) {
			e.preventDefault();
			e.stopPropagation();
			browserHistory.push('/profile/' + userCodeElement.text);
		}
	}

	public render() {
		const { t, isDragging } = this.props;
		const { elements } = this.props.sectionItem;
		const addedDate: string = (elements[3] as ISectionTextElement)
			? moment((elements[3] as ISectionTextElement).text).format('L')
			: null;

		return (
			<div className="portalPageArticleItem articleItemCard commonItemCard">
				<a
					href="#"
					onClick={(e) => {
						this.onCardClick(e, (elements[1] as ISectionTextElement).redirectUrl, isDragging);
					}}
				>
					<div
						className="articleImage imageHolder"
						style={{ backgroundImage: `url(${thumbUrl((elements[0] as ISectionImageElement).imageUrl)})` }}
					>
						<img {...imgSrcAttributes((elements[0] as ISectionImageElement).imageUrl)} className="image" />
					</div>
					<div className="itemDetail">
						<div className="published">{moment(addedDate).format('L')}</div>
						<div className="title">{truncateText((elements[1] as ISectionTextElement).text, 40)}</div>
						<div
							className="author"
							onClick={(e) => {
								this.onAuthorClick(e, elements[4] as ISectionTextElement, isDragging);
							}}
						>
							{t('BSPortal_Common_By')} <span className="byName">{(elements[2] as ISectionTextElement).text}</span>
						</div>
					</div>
				</a>
			</div>
		);
	}
}

export { ViewSectionItemArticle };
